import { useEffect, useState } from 'react';

const computeTime = (hi, low) => {
  hi = hi || Date.now();
  low = low || Date.now();

  let ms = hi - low;

  let s = Math.floor((ms / 1000) % 60);
  let m = Math.floor((ms / 1000 / 60) % 60);
  let h = Math.floor((ms / 1000 / 3600) % 24);

  let hh = h.toFixed(0).padStart(2, '0');
  let mm = m.toFixed(0).padStart(2, '0');
  let ss = s.toFixed(0).padStart(2, '0');

  if (hh !== '00') return `${hh}:${mm}:${ss}`;
  return `${mm}:${ss}`;
};

const Timer = props => {
  // Bug real (auditoría 2026-08-16): useState('00:00') hardcodeaba el
  // primer render — el cálculo real (hi-low) sólo corría dentro del
  // setTimeout de 1seg, así que abrir la HCE de una consulta ya activa
  // hace 15min mostraba "00:00" por hasta un segundo antes de saltar a
  // "15:00". Se calcula el valor real desde el primer render.
  let [time, setTime] = useState(() => computeTime(props.hi, props.low));

  useEffect(() => {
    let tick = setTimeout(() => {
      setTime(computeTime(props.hi, props.low));
    }, 1000);

    return () => clearTimeout(tick)
  }, [time, props.hi, props.low]);

  return time || ''
}

export default Timer;
